import { hot } from 'react-hot-loader/root';
import * as React from 'react';
import { Router, Route, RouteComponentProps } from 'react-router-dom';
import HomeownersInsurance from './HomeownersInsurance';
import history from './history';
import ScrollToTop from '../components/ScrollToTop';
import { HOMEOWNERS_BASE_URL } from './constants';

const Routes = () => (
  <Router history={history}>
    <ScrollToTop>
      <Route
        path={HOMEOWNERS_BASE_URL}
        render={(props: RouteComponentProps) => <HomeownersInsurance {...props} />}
      />
    </ScrollToTop>
  </Router>
);

export default hot(Routes);
